import { FC } from 'react';
import { CardHeaderProps, Typography, CardHeader } from '@mui/material';

import { addSpacesBeforeUpperCase } from '/helpers';

interface ITitle extends CardHeaderProps {
  action?: React.JSX.Element;
  subheader?: string;
  title?: string;
}
export const Title: FC<ITitle> = ({ action, subheader, title, ...rest }) => {
  const customTitle = <Typography variant='h5'>{addSpacesBeforeUpperCase(title || 'Unknown')}</Typography>;

  return <CardHeader title={customTitle} action={action} subheader={subheader} {...rest} />;
};
